interface Msg { role: "user" | "assistant"; content: string; }

/** Chat com o agente de IA de uma galáxia. A chave fica no backend (/api/agent). */
export class Agent {
  private el!: HTMLElement;
  private msgsEl!: HTMLElement;
  private input!: HTMLInputElement;
  private titleEl!: HTMLElement;
  private galaxyLabel = "";
  private context = "";
  private history: Msg[] = [];
  private busy = false;

  mount(root: HTMLElement) {
    root.insertAdjacentHTML(
      "beforeend",
      `<div id="agent" class="panel">
        <div class="agent-head"><span id="agent-title">Agente</span><button id="agent-close" aria-label="fechar">×</button></div>
        <div id="agent-msgs"></div>
        <form id="agent-form">
          <input id="agent-input" placeholder="pergunte ao agente…" autocomplete="off" />
          <button type="submit" aria-label="enviar">➤</button>
        </form>
      </div>`,
    );
    this.el = root.querySelector("#agent") as HTMLElement;
    this.msgsEl = root.querySelector("#agent-msgs") as HTMLElement;
    this.input = root.querySelector("#agent-input") as HTMLInputElement;
    this.titleEl = root.querySelector("#agent-title") as HTMLElement;
    (root.querySelector("#agent-close") as HTMLElement).addEventListener("click", () => this.hide());
    (root.querySelector("#agent-form") as HTMLFormElement).addEventListener("submit", (e) => {
      e.preventDefault();
      this.send();
    });
  }

  open(label: string, context: string) {
    this.galaxyLabel = label;
    this.context = context;
    this.history = [];
    this.titleEl.textContent = `✦ Agente · ${label}`;
    this.msgsEl.innerHTML = "";
    this.addMsg("assistant", `Sou o agente de ${label}. Pergunte sobre estratégia, conexões ou próximos passos deste domínio.`);
    this.el.classList.add("open");
    setTimeout(() => this.input.focus(), 300);
  }
  hide() { this.el.classList.remove("open"); }

  private addMsg(role: "user" | "assistant", text: string): HTMLElement {
    const d = document.createElement("div");
    d.className = `agent-msg ${role}`;
    d.textContent = text;
    this.msgsEl.appendChild(d);
    this.msgsEl.scrollTop = this.msgsEl.scrollHeight;
    return d;
  }

  private async send() {
    const q = this.input.value.trim();
    if (!q || this.busy) return;
    this.input.value = "";
    this.addMsg("user", q);
    this.busy = true;
    const pending = this.addMsg("assistant", "…");
    pending.classList.add("typing");
    try {
      const r = await fetch("/api/agent", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ galaxy: this.galaxyLabel, message: q, context: this.context, history: this.history.slice(-8) }),
      });
      const data = await r.json().catch(() => ({}));
      pending.classList.remove("typing");
      if (data.text) {
        pending.textContent = data.text;
        this.history.push({ role: "user", content: q }, { role: "assistant", content: data.text });
      } else if (data.error === "missing_key") {
        pending.textContent = "⚠️ O agente ainda não está ativo: falta configurar a chave da IA no servidor.";
      } else {
        pending.textContent = `⚠️ ${data.message || data.error || "não consegui responder agora."}`;
      }
    } catch {
      pending.classList.remove("typing");
      pending.textContent = "⚠️ Sem conexão com o serviço do agente.";
    }
    this.busy = false;
  }
}
